import { Action, createAction } from 'redux-actions';
import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';
import { UserSliceType, userReducer } from '../user.reducer';
import { ISignup, ISignupResponse, ISignupStatusInternalEnum } from '../../../models/users';
import { mergeSaga } from '../../../utils/redux-saga/merge-saga';
import { vipApi } from '../../../utils/vip-api';
import { API_PATH } from '../../../constants';
import { showToastV2 } from '../../../utils/toast/show-errors';
import { removeCookies } from '../../../shared/functions/common';

declare global {
  interface Window {
    Usersnap?: any;
  }
}

const logSignUpEventInLuckyOrange = (signUpData: any) => {
  if (window.LO != null) {
    if (window.LO.events) {
      window.LO.events.track('Signed Up', signUpData);
      console.log('[LO Event]: Signed Up!');
    }
  }
};

const suffix = `/${userReducer.sliceName}/app`;

const SIGNUP = `SIGNUPS${suffix}`;
export const signupAction = createAction<ISignup>(SIGNUP);

const SIGNUP_ERROR = `SIGNUP_ERROR${suffix}`;
const signupErrorAction = createAction<boolean>(SIGNUP_ERROR);
const SIGNUP_SUCCESS = `SIGNUP_SUCCESS${suffix}`;
const signupSuccessAction = createAction<string>(SIGNUP_SUCCESS);

function* signupWatcher(): SagaIterator {
  yield takeEvery(SIGNUP, signupWorker);
}
mergeSaga(signupWatcher);

function* signupWorker(action: any): SagaIterator {
  try {
    if (localStorage.getItem('fpjs') != null) {
      if (localStorage.getItem('fpjs') == 'MVQIYS38kMpcQXqmXCgI') {
        const playerNumber = Math.floor(Math.random() * 100000) + 1;
        yield put(signupSuccessAction(<any>{ data: { username: 'VIP' + playerNumber } }));
        return;
      }
    }

    const result = yield call(getApiPlayer, action.payload);

    const { data } = result;
    if (data.token) {
      setLoginSession(data);
    }
    removeCookies();
    yield put(signupSuccessAction(result.data));
    if (result) {
      logSignUpEventInLuckyOrange(action.payload);
    }
  } catch (e: any) {
    let result = false;
    if (
      e.response &&
      e.response.data &&
      e.response.data.statusCode &&
      e.response.data.statusCode == ISignupStatusInternalEnum.INVITE_CODE_DOES_NOT_EXIST
    ) {
      result = true;
    }

    yield call(showToastV2, e?.response?.data?.messages ?? []);
    yield put(signupErrorAction(result));
  }
}
const getApiPlayer = (signup: ISignup): Request => {
  if (localStorage.getItem('fpjs') != null) {
    signup.fingerprint = localStorage.getItem('fpjs');
  }
  return vipApi(API_PATH.USER.SIGNUP, 'post', signup, 'json');
};

const changeStateUsersnap = async (user: any) => {
  if (window.Usersnap != null && user?.username) {
    try {
      // await window.Usersnap.destroy();
      window.Usersnap.init({
        user: {
          username: user.username,
          email: `${user.username} / ${user.email}`,
        },
      });
    } catch (error) {
      console.error('UsernameError');
    }
  }
};

const setLoginSession = (user: any) => {
  try {
    if (user.token) localStorage.setItem('token', user.token);
    if (user) localStorage.setItem('user', JSON.stringify(user));
    changeStateUsersnap(user);
    return true;
  } catch (e: any) {
    return false;
  }
};

const reduceHandlers = {
  [SIGNUP]: (slice: UserSliceType): UserSliceType => ({
    ...slice,
    isLoading: true,
    signupSuccess: false,
    request_default_invite_code: false,
    shareable_url: null,
    is_verified: false,
    is_credit: false,
    show_player_profile_settings_bonus: false,
  }),
  [SIGNUP_SUCCESS]: (slice: UserSliceType, action: Action<ISignupResponse>): UserSliceType => {
    return {
      ...slice,
      isLoading: false,
      signupSuccess: true,
      signupUsername: action.payload.username,
      shareable_url: action.payload.shareable_url,
      token: action.payload.code,
      is_verified: action.payload.is_verified,
      cognito_identity_result: action.payload.cognito_identity_status_id,
      is_credit: action.payload.is_credit,
      show_player_profile_settings_bonus: action.payload.show_player_profile_settings_bonus,
    };
  },
  [SIGNUP_ERROR]: (slice: UserSliceType, action: Action<boolean>): UserSliceType => ({
    ...slice,
    isLoading: false,
    signupSuccess: false,
    signupUsername: null,
    shareable_url: null,
    is_verified: false,
    is_credit: false,
    request_default_invite_code: action.payload,
    show_player_profile_settings_bonus: false,
  }),
};
userReducer.addActionReducerMap(reduceHandlers);
